import { getOrgUuid } from "state/current_user/selectors";
import { formatOrgPrefixedPath } from "utils/common";

import { useSelector } from "./redux";

export const useOrgPrefixedPath = (path: string) => {
  const organizationId = useSelector(getOrgUuid);
  return formatOrgPrefixedPath(organizationId, path);
};

export const useVehiclePagePath = (vehicleId: string) => {
  return useOrgPrefixedPath(`/fleet/flights?vehicleId=${vehicleId}`);
};

export const useBatteryLink = (batterySerial: string, batteryDevicePageEnabled = false) => {
  const batteryPage = useOrgPrefixedPath(`/settings/devices/batteries`);
  if (batteryDevicePageEnabled) {
    return `${batteryPage}/${batterySerial}`;
  }
  return `${batteryPage}?batterySerial=${batterySerial}`;
};

export const useAttachmentLink = (
  attachmentSerial: string,
  attachmentDevicePageEnabled = false
) => {
  const attachmentsPage = useOrgPrefixedPath(`/settings/devices/attachments`);
  if (attachmentDevicePageEnabled) {
    return `${attachmentsPage}/${attachmentSerial}`;
  }
  return `${attachmentsPage}?attachmentSerial=${attachmentSerial}`;
};

export const useGimbalLink = (gimbalSerial: string, sensorPackageDetailsEnabled = false) => {
  const sensorPackagePage = useOrgPrefixedPath(`/settings/devices/sensorPackages`);
  if (sensorPackageDetailsEnabled) {
    return `${sensorPackagePage}/${gimbalSerial}`;
  }
  return `${sensorPackagePage}?sensorPackageSerial=${gimbalSerial}`;
};

export const useBatteryFlightLink = (
  batterySerial: string,
  takeoffSince: string,
  takeoffBefore: string
) => {
  return useOrgPrefixedPath(
    `/reports/flights?batterySerial=${batterySerial}&takeoffSince=${takeoffSince}&takeoffBefore=${takeoffBefore}`
  );
};

export const useResourceGroupsPagePath = (rgUuid = "") => {
  return useOrgPrefixedPath(`/settings/resource-groups${rgUuid ? `/${rgUuid}` : ""}`);
};

export const useVehicleLink = (vehicleId: string) => {
  return useOrgPrefixedPath(`/fleet/flights?vehicleId=${vehicleId}`);
};

export const useFlightLink = (flightUuid: string, vehicleId: string) => {
  return useOrgPrefixedPath(`/fleet/flight/${flightUuid}?vehicleId=${vehicleId}`);
};

export const useOverrideLink = (overrideKey: string) => {
  // link to team page with loginOverriden=true and loginTypes=overrideKey
  // loginOverriden=true will filter users to only those that have their login types overridden from the org defaults
  return useOrgPrefixedPath(`/settings/team?loginOverriden=true&loginTypes=${overrideKey}`);
};

export const useDroneLink = (droneSerial: string) => {
  return useOrgPrefixedPath(`/settings/devices/vehicles/${droneSerial}`);
};
